/**
 *
 * 广发证券
 *
 */

import { getUrlParam } from '@/utils/api';
import { isBuild } from '@/utils/const';

const comein_channel = 'guangfazq';

export const isThirdParty = getUrlParam().comein_channel === comein_channel;

function Bridge() {
	this.title = '广发证券';

	this.comein_channel_pc = 'gfzq';

	this.comein_channel = comein_channel;

	this.bolUc = false;

	this.instituteUser = {
		// showEmail: true,
		showHistory: true,
		showAttention: true
	};

	this.authMethod = 1;

	// 以前部分接口需要传zid、后面改成传uc
	this.zid = isBuild ? 87 : 159;
	this.uc = isBuild ? '7e6665c6-041b-4ca7-9282-bb15feb2ce04' : 'ac9202f1-65a1-4be2-8baa-f7b9ebfb73b7';

	this.instituteLogin = {
		loginWay: [0]
	};

	this.bindPhone = {
		loginWay: [0]
	};
}

// 获取分享配置
Bridge.prototype.getShareData = function () {
	return {
		title: '广发证券',
		desc: '中信证券研究部秉持“激情、创新、整合、卓越”的价值理念，以前沿技术的深度研究、行业趋势的前瞻预测和公司价值的准确把握为努力方向，旨在为国内外专业投资者提供决策建议和参考，同时也为政策制定者献计献策',
		link: location.href,
		img_url: 'https://image.comein.cn/comein-files/img/default/guangfalogo.png'
	};
};

export default Bridge;
